
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "protocolDetail",
})

export default class protocolDetail extends Vue {
	
  data() {
    return {
		dialogImageUrl: '',
        dialogVisible: false,
		isEdit:true,
		form:{},
    }
  };

  private mounted() {
	
	let tempData = {};
	let id = this.$route.query.id;
	this.$http.get("agreements/"+id, {}).then((res: any) => {
		tempData = res.data.data;
		this.form = tempData;
		console.log('radio',tempData);
	});
  }

  private onCancel(){
	  
	  console.log('取消')
	  this.$router.back();
  }

  private onSubmit(){

      console.log('////',this.form);
      // 新增协议
      let paramter = {
        agreements:this.form.agreements,
        appName:this.form.appName,
        content:this.form.content,
        type:this.form.type,
        id:this.form.id
      };
      this.$http.put("agreements/update", paramter).then((res: any) =>{
        
          this.$confirm('修改成功');
          this.dialogVisible = false;
          window.location.reload();
      });
  }
}
